import { Link } from '@cian/ui-kit';
import React from 'react';

type TProps = {
  href: string;
  count: number;
  text: string;
  onClick: () => void;
};

export const ContentTabLink: React.FC<TProps> = ({ href, count, text, onClick }) => {
  const linkText = `Смотреть все ${count} ${text}`;

  if (!href || !count) {
    return null;
  }

  return (
    <Link href={href} target="_blank" color="current_color" fontWeight="bold" onClick={onClick}>
      {linkText}
    </Link>
  );
};
